<!--
 * @Author: your name
 * @Date: 2021-11-24 17:48:53
 * @LastEditTime: 2022-06-22 10:28:22
 * @LastEditors: shijianchen shijianchen@tujia.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/frontlander/components/video.vue
-->
<template>
  <div>
    <video :id="videoId"
      v-maidian="'video'"
      controls
      :src="src"
      :poster="poster"
      webkit-playsinline="true"
      x-webkit-airplay="true"
      playsinline="true"
      x5-video-player-type="h5"
      x5-video-orientation="h5"
      x5-video-player-fullscreen="true"
      preload="auto"
      class="video__player poster"
    >
      抱歉，您的浏览器不支持内嵌视频
    </video>
  </div>
</template>

<script>
import maidian from "@/utils/maidian";

export default {
  name: "app",
  props: ["src", "poster","videoId"],
  data() {
    var vm = this;
    return {
      videoList_1: {
        src: "https://picbed.qunarzz.com/e82c4d19b7139eb1084424240691b725.mp4",
        isStart: true,
        poster:
          "https://picbed.qunarzz.com/7e6994ebd0fff0654fdc15fd47ae95f9.png",
      },
      videoList_2: {
        src: "https://picbed.qunarzz.com/a26a0bc09d7fabc61298a5ea5aa2d321.mp4",
        isStart: true,
        poster:
          "https://picbed.qunarzz.com/202293580c73fc86156a621b7bdd3d79.png",
      },
    };
  },
  mounted() {
    let self = this;
    let video = document.getElementById(this.videoId);
    video.addEventListener("playing", function () {
      maidian.eventBind(self.videoId);
      self.$emit("playing");
    });
  },
  methods:{
    pause(){
      document.getElementById(this.videoId).pause();
    }
  }
};
</script>

<style lang="less" scoped="true">
.video__player {
  width: 100%;
}
</style>
